module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "c005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('b', [_vm._v("c. 850")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter0"
  }, [_c('i', [_vm._v("On Deciphering Cryptographic Messages")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent_line"
  }, [_c('b', [_vm._v("Abu Yusuf Ya’qub ibn Ishaq al-Sabbah Al-Kindi")]), _vm._v(" (c. 801–c. 873)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Early encryption methods were accomplished in two ways: changing the position of words or letters in a message, called "), _c('i', [_vm._v("transposition,")]), _vm._v(" or replacing the letters in a message with a different set of letters, called "), _c('i', [_vm._v("substitution.")]), _vm._v(" With 26 letters in the English alphabet, the number of combinations that either technique could yield was so large that messages encrypted with simple transposition or substitution seemed sufficiently safe from decryption without knowing the approach that had been used to scramble or substitute the letters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The security of these techniques changed with a man named Al-Kindi, known as the “Philosopher of the Arabs,” who systematically developed approaches for breaking all existing encryption methods that had been developed. Now encrypted messages could be solved in minutes, without knowing how they had been encrypted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Born in the Iraqi city of Basra and schooled in Baghdad, Al-Kindi mastered a vast range of intellectual disciplines, including medicine, astronomy, mathematics, linguistics, astrology, optics, and music, and he wrote more than 290 books. Al-Kindi was appointed director of the House of Wisdom, an institution that, among other things, translated Greek texts en masse from the Byzantine Empire. Among the plethora of foreign material that arrived for translation, some were encrypted texts that codemakers had created for kings, generals, and important politicians. Combining his knowledge of linguistics and mathematics, Al-Kindi may have sought to “translate” these coded documents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The techniques that Al-Kindi discovered were based on statistical analysis of encrypted texts, especially letter-frequency analysis, combined with techniques based on trial decodings of probable words and vowel-consonant combinations. He recorded his methods in a book called "), _c('i', [_vm._v("Risalah fi Istikhraj al-Mu’amma")]), _vm._v(" ("), _c('i', [_vm._v("A Manuscript on Deciphering Cryptographic Messages")]), _vm._v("). Beyond being the world’s first treatise on cryptanalysis, it was also one of the first times that statistical techniques were described in a book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Al-Kindi’s book was lost and rediscovered in the 1980s at the Sulaimaniyyah Ottoman Archive in Istanbul, and later published by the Arab Academy of Damascus in 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('b', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c027_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vernam Cipher (1917)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("Abu Yusuf Ya’qub ibn Ishaq al-Sabbah Al-Kindi, known in the West in the 9th century CE as the “Philosopher of the Arabs,” wrote the world’s first treatise on cryptanalysis.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/25-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3883faa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_c005_r1.vue
// module id = 87
// module chunks = 0